<template>
  <section class="blockElement fix-mt">
    <!--<div class="sessionexpriedouter" v-if="parseInt(get_user.verified_status) == 0">
			<div class="cbox">
				<h3>Verify your account</h3>
				<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
				<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
        		<div class="verify-link mb-5">
				    <input type="text" placeholder="Type your 6 digit OTP..." class="form-control mb-2" v-model="otp" name="otp" v-validate="'required|numeric|max:6'">
					<span v-show="submitted && errors.has('otp')" class="text-danger">{{ errors.first('otp') }}</span>
				    <a href="#" clsas="pull-left" @click="resend()">Resend OTP. <feather type="refresh-cw" size="1em" class=" custom-class secondIcon"></feather></a>
				</div>
        		<div class="bottom-buttons">
				<button class="verifyBtn red-bg" @click="logout()">Logout</button>
        			<button class="verifyBtn" v-on:click="verify_lead()">Submit</button>
        		</div>
			</div> 
		</div>-->
    <div class="sessionexpriedouter" v-if="sessionexpired">
      <!-- <div class="cbox">
				<div class="mb-3">
					<img src="../../../static/fxView/images/session_expired.png" alt="session expired" width="200">
				</div>
				<p class="mb-3">Your session has expired. Please login again</p>
				<a role="menuitem" class="prism_btn btn_sm" tabindex="-1" href="#" @click="logout()">{{$t('Okay')}} </a>
			</div>  -->
    </div>
    <div class="customFlex-wrapper">
      <app-left-navbar
        :classMobileResponsive="classMobileResponsive"
        v-if="$route.path != '/web-trade-link' || $route.path != '/new-web-trade-link'"
      ></app-left-navbar>
      <div
        class="rightArea dashboard vh_100 whiteBG"
        :class="$route.path == '/web-trade-link' || $route.path == '/new-web-trade-link' ? 'Webtradercontainer' : ''"
      >
        <app-header :show_tab="show_header_tab"></app-header>
        <div class="scrollbar mainContent">
          <div class="mainContentOuter container">
            <router-view />
          </div>
          <div class="ftrTxt">
            <p>{{ $t("footerMsz1") }}</p>
          </div>
          <div class="fixedBarBottom">
            <div class="footPromoLastBar text-center">
              <p v-html="$t('footerMsz2')"></p>
              <a
                href="https://fxview.com/assets/pdf/legal-document/Risk-Disclosure-and-Warnings-Notice-August-2023.pdf"
                target="_blank"
                >{{ $t("riskDisclaimer") }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as types from "../../types";
import { mapActions } from "vuex";
import Header from "./shared/header";
import leftNavbar from "./shared/left_navbar";
import { fxViewMixins } from "@/plugins/fxView";
import { Const } from "@/plugins/fxView/provider/candle-history/lib/const.cls";
import i18n from "@/plugins/lang/i18n";
export default {
  name: "FXVIEW",
  mixins: [fxViewMixins],
  data() {
    return {
      response_msg: "",
      msg_type: "",
      show_header_tab: "",
      classMobileResponsive: false,
      pageLoader: false,
      demoAcountDeposit: false,
      sessionexpired: false,

      submitted: false,
      otp: "",
    };
  },
  components: {
    appHeader: Header,
    appLeftNavbar: leftNavbar,
  },
  methods: {
    ...mapActions({
      _runUserLogout: types.RUN_USER_LOGOUT,
      _runVerifyLeadOtp: types.RUN_VERIFY_LEAD_OTP,
      _runUserSignUp: types.RUN_USER_SIGNUP,
    }),
    resend() {
      /*const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(this.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');*/
      let input_json = {
        globalParams: {
          //"email": this.email,
          //"mobile": this.numberWithCountry,
          //"password" : hashedstr,
          //"captchaToken":this.captchaToken,
          //"IBREFERLINK":this.IBREFERLINK
        },
        localParams: { parameter: this, page: "resend" },
      };
      this._runUserSignUp(input_json);
    },
    verify_lead() {
      /*const _that = this
                _that.submitted = true;

                const mykey = crypto.createCipher('aes-128-cbc', 'F*V(I)e^E#1108@3');
                let hashedstr = mykey.update(_that.password, 'utf8', 'hex')
                hashedstr += mykey.final('hex');*/

      _that.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              //"email": _that.email,
              //"mobile": _that.numberWithCountry,
              //"password" : hashedstr,
              OTP: _that.otp,
              //"ID": _that.insertId,
              //"IBREFERLINK":_that.IBREFERLINK
            },
            localParams: { parameter: _that },
          };
          _that._runVerifyLeadOtp(input_json);
        } else {
          _that.handleValidationErrorAdvanced(_that.errors);
        }
      });
    },
    logout() {
      const _that = this;
      let input_json = {
        globalParams: {},
        localParams: {
          parameter: _that,
        },
      };
      _that._runUserLogout(input_json);
    },
    changeLocale(locale) {
      i18n.locale = locale;
    },
  },
  mounted: function () {
    const _that = this;
    window.addEventListener("storage", (e) => {
      console.log("e", e);
      if (
        localStorage.getItem("unauthFlag") &&
        localStorage.getItem("unauthFlag") == "true"
      ) {
        _that.sessionexpired = true;
        _that.logout();
      } else {
        _that.sessionexpired = false;
      }
    });
  },
  created() {
    const _that = this;

    if (
      localStorage.getItem("unauthFlag") &&
      localStorage.getItem("unauthFlag") == "true"
    ) {
      _that.sessionexpired = true;
      _that.logout();
    } else {
      _that.sessionexpired = false;
    }

    this._runGetUserProfile({
      globalParams: {},
      localParams: { parameter: this, loaderFuncRun: 1 },
    });

    this._runGetCountriesList({
      globalParams: {},
      localParams: { parameter: this },
    });
    this._runGetTradingAccountList({
      globalParams: {},
      localParams: { parameter: this },
    });
    this._runUserNotification({
      globalParams: {},
      localParams: { parameter: this },
    });
    this._runGetTicketReasonList({
      globalParams: {},
      localParams: { parameter: this },
    });

    if (
      localStorage.getItem("lang") &&
      this.get_user.lang != localStorage.getItem("lang")
    ) {
      this._runLanguageApi({
        globalParams: { lang: localStorage.getItem("lang") },
        localParams: { parameter: this, page: "left-bar" },
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/index.vue